import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0639bc12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_3 = { class: "key-container" }
const _hoisted_4 = { class: "deal-title" }
const _hoisted_5 = { class: "deal-name bold large" }
const _hoisted_6 = { class: "talks" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "talkCount" }
const _hoisted_9 = { class: "deal-details" }
const _hoisted_10 = { class: "small" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0px 10px","color":"#D9DEE8","height":"50%"} }, "|")
], -1))
const _hoisted_12 = { class: "status name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "협의", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0px 10px","color":"#D9DEE8","height":"50%"} }, "|")
], -1))
const _hoisted_15 = { class: "thunIcon" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "thunText" }, " 바로구매 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divide" }, null, -1))
const _hoisted_19 = { class: "deal-center" }
const _hoisted_20 = { class: "price-info" }
const _hoisted_21 = { class: "deals-price" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "가격", -1))
const _hoisted_23 = { class: "div" }
const _hoisted_24 = { class: "bold large" }
const _hoisted_25 = { class: "deals-percent" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "지분율", -1))
const _hoisted_27 = { class: "bold large" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divide" }, null, -1))
const _hoisted_29 = { class: "deal-total" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 총 ")
const _hoisted_31 = { class: "bold" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_33 = { class: "deal-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.deal.name), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            class: "talk-icon",
            src: _ctx.talkIcon,
            alt: "icon"
          }, null, 8, _hoisted_7),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.deal.comment), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", null, _toDisplayString(_ctx.deal.user), 1),
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_ctx.deal.date), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", { src: _ctx.thunder }, null, 8, _hoisted_16),
            _hoisted_17
          ])
        ])
      ])
    ]),
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$filters.currency(_ctx.deal.price)) + " 원", 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.deal.percent) + " %", 1)
      ])
    ]),
    _hoisted_28,
    _createElementVNode("div", _hoisted_29, [
      _hoisted_30,
      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$filters.currency(_ctx.deal.total)), 1),
      _hoisted_32
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("button", {
        class: "leftBtn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
      }, " 판매자와 협의 "),
      _createElementVNode("button", {
        class: "rightBtn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeView && _ctx.closeView(...args)))
      }, " 바로구매 ")
    ])
  ]))
}